module.exports = __webpack_public_path__ + "img/communication3.49043c57.png";